import { Employee } from './employee/employee';
import { Mission } from './mission/mission';
import { Route } from './route';

export class Planning {
	readonly id: number;
	employee: Employee;
	tempsTravailleDay: number;
	tempsPerduDay: number;
	tempsTravailleWeek: number;
	tempsPerduWeek: number;
	speNoRespecte: number;
	chargePlanning: number;
	timeStartDay: number;
	timeDispo: number;
	pauseDej: boolean;
	routes: Route[];
}
